import React, { Component } from 'react'
import { brandsService } from '../../_services/brands.service'
import { Dropdown } from 'semantic-ui-react'


class AsyncBrandSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      defaultValue: this.props.defaultValue,
      data: [],
    };
  }

  componentWillMount() {
    this.getData();
  }

  getData() {

    this.setState({ loading: true })
    brandsService.getAll(this.props.brandType)
      .then((res) => {
        let data = res.data.map(elm => ({ "text": elm.name, "value": elm.id }))
        this.setState({ data: data, loading: false, isSubmitting: false });
      }).catch((error) => {
        this.setState({ loading: false })
        // console.log(error)
      });

  };


  async componentWillReceiveProps(nextProps) {

    if (nextProps.defaultValue !== this.state.defaultValue) {
      this.setState({ defaultValue: nextProps.defaultValue });
    }

    if (nextProps.brandType !== this.state.brandType) {
      this.setState({ brandType: nextProps.brandType }, () => {
        this.getData();
      });
    }

    if (nextProps.disabled !== this.state.disabled) {
      this.setState({ disabled: nextProps.disabled });
    }

  }

  handleChange = (e) => {

    let selected = e;
    this.setState({ selected: selected })
    this.props.onChange(selected)

  }

  render() {

    const { data, loading, defaultValue, disabled } = this.state;
    const { clearable, className, placeholder } = this.props;

    return (
      <Dropdown
        placeholder={placeholder}
        fluid
        search
        selection
        basic
        onChange={(e, data) => this.handleChange(data.value)}
        value={defaultValue}

        className={className}
        options={data}
        wrapSelection={false}
        selectOnBlur={false}
        searchInput={{ autoFocus: false }}
        loading={loading}
        disabled={disabled}
        clearable={clearable}
      />
    );
  }
}
export default AsyncBrandSelect;
